export default function LogoMark({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <clipPath id="lg-clip">
          <rect width="64" height="64" rx="20" />
        </clipPath>
        <mask id="lg-cut">
          <path d="M6 48 V23 q0-3 3-3 h16 q3 0 3 3 v25 z" fill="#fff" />
          <path d="M28 48 V33 q0-3 3-3 h11 q3 0 3 3 v15 z" fill="#fff" />
          <rect x="10" y="25" width="6" height="9" rx="3" fill="#000" />
          <rect x="18" y="25" width="6" height="9" rx="3" fill="#000" />
          <rect x="10" y="38" width="6" height="10" rx="3" fill="#000" />
          <rect x="18" y="38" width="6" height="10" rx="3" fill="#000" />
          <rect x="32" y="37" width="6" height="11" rx="3" fill="#000" />
        </mask>
      </defs>
      <g clipPath="url(#lg-clip)">
        <rect x="0" y="0" width="21.33" height="64" fill="#009246" />
        <rect x="21.33" y="0" width="21.34" height="64" fill="#F1F2F1" />
        <rect x="42.67" y="0" width="21.33" height="64" fill="#CE2B37" />
      </g>
      <g mask="url(#lg-cut)">
        <rect width="64" height="64" fill="#141414" />
      </g>
      <path d="M54 15 L44 30 h6 l-3 13 10-16 h-6 z" fill="#FFC300" />
      <g transform="translate(53 42) rotate(-45)">
        <rect x="-3" y="-11" width="6" height="13" rx="3" fill="#FFC300" />
        <rect x="-1.2" y="2" width="2.4" height="11" rx="1.2" fill="#FFC300" />
      </g>
    </svg>
  );
}
